var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{active: _vm.active},on:{"click":_vm.nextPage}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }